import { InstrumentResource, useInstrumentSearchCommon } from '@eih-netbroker/common';
import { useMemo } from 'react';
import { useLocale } from '../../context/NbLocalizationContext';
import { useResource, useResourceHeaders } from './useResource';

export const useInstrumentSearch = () => {
  const instrumentResource = useResource(InstrumentResource);
  const { getResourceHeaderWithToken } = useResourceHeaders();
  const { translation } = useLocale();

  const p = useMemo(
    () => ({
      translation: {
        unknown: translation.instrument.unknown,
      },
      getResourceHeaderWithToken,
      instrumentResource,
    }),
    [instrumentResource, getResourceHeaderWithToken, translation],
  );

  return useInstrumentSearchCommon(p);
};
